"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Confetti = void 0;
const Block_1 = require("./Block");
const pixi_js_1 = require("pixi.js");
const lodash_1 = __importDefault(require("lodash"));
const Global_1 = require("../Global");
class Fetti extends pixi_js_1.Graphics {
    // Just to get Typescript to stop wining :(
    setTransform(x, y, scaleX, scaleY, rotation, skewX, skewY, pivotX, pivotY) {
        return super.setTransform(x, y, scaleX, scaleY, rotation, skewX, skewY, pivotX, pivotY);
    }
}
class Confetti extends Block_1.Block {
    constructor(app, w, h, amount = 120, blur = 0, fromtop = false) {
        super(app);
        this.w = w;
        this.h = h;
        this.amount = amount;
        this.blur = blur;
        this.fromtop = fromtop;
        this.blurs = [];
        this.color = [0xffffff, 0xff2a5c, 0xe4ff2a, 0xa62aff, 0x3df2da, 0xff2a9c, 0x2aff9f];
        this.ticker = new pixi_js_1.Ticker();
        this.updater = () => {
            this.update(this.ticker.deltaTime);
        };
        this.ticker.speed = 1;
        this.ticker.add(this.updater);
        this.ticker.start();
        this.makeFetti();
    }
    /*    setSize(width: number, height: number, amount: number = 120){
            this.w = width;
            this.h = height;
            this.amount = amount;
            this.layout();
        }*/
    makeFetti() {
        // First remove confetti
        while (this.children[0]) {
            (this.children[0]).destroy();
        }
        // Add confetti
        const numLayers = 3;
        const layers = lodash_1.default.times(numLayers, (i) => {
            const c = new pixi_js_1.Container();
            if (this.blur) {
                const b = new pixi_js_1.BlurFilter((0, Global_1.px)(this.blur * (i / numLayers)), 1.8);
                this.blurs.push(b);
                c.filters = [b];
            }
            this.addChild(c);
            return c;
        });
        for (let i = 0; i < this.amount; i++) {
            const size = (0, Global_1.px)(lodash_1.default.random(7, 9, true));
            const colornum = i % this.color.length;
            let x = Math.floor(Math.random() * this.w) + 10;
            let y = Math.floor(Math.random() * this.h);
            if (this.fromtop) {
                y = (y * -1) + (0, Global_1.px)(32);
            }
            const graphic = (new Fetti())
                .beginFill(this.color[colornum], lodash_1.default.random(0.85, 1, true))
                .drawRoundedRect(-size / 2, -size / 2, size, size, (0, Global_1.px)(1));
            graphic.dir = (i % 2 === 0 ? 1 : -1);
            graphic.skewer = lodash_1.default.random(-0.1, 0.1, true);
            graphic.rotater = lodash_1.default.random(-0.03, 0.03, true);
            graphic.mover = Math.max((Math.abs(graphic.skewer) + Math.abs(graphic.rotater)) * 2, 0.1);
            graphic.position.set(x, y);
            graphic.scale.set(lodash_1.default.random(7, 10) / 10);
            graphic.skew.y = graphic.skewer;
            graphic.rotation = graphic.rotater;
            layers[i % layers.length].addChild(graphic);
        }
    }
    update(delta) {
        const factor = delta;
        this.children.forEach((layer) => {
            layer.children.forEach((graphic) => {
                let y;
                if (graphic.y > this.h) {
                    y = -graphic.height;
                }
                else {
                    y = graphic.y + (graphic.mover * 7 * factor);
                }
                if (graphic.x > this.w - graphic.width) {
                    graphic.dir = -1;
                }
                else if (graphic.x < graphic.width) {
                    graphic.dir = 1;
                }
                graphic.position.set(graphic.x + (graphic.mover * graphic.dir * factor), y);
                graphic.skew.y += graphic.skewer * factor;
                graphic.rotation += graphic.rotater * factor;
            });
        });
    }
    destroy(_options) {
        super.destroy(_options);
        this.ticker.destroy();
        this.blurs.forEach((b) => b === null || b === void 0 ? void 0 : b.destroy());
    }
}
exports.Confetti = Confetti;
